import panoramaBadge from './static/360-badge.png';
import bestSale from './static/best_sale.png';
import laptop from './static/laptop.png';
import logoWhite from './static/logo-white.png';
import logo from './static/microsoft.png';
import mobile from './static/mobile.png';
import mobile3 from './static/mobile3.png';
import mouse from './static/mouse.png';
import panorama from './static/panorama.png';
import shield from './static/shield.png';
import surfaceLaptop from './static/surface_laptop.png';
import surfaceLaptop2 from './static/surface_laptop2.png';
import tablet1 from './static/tablet1.png';
import tablet2 from './static/tablet2.png';
import visualStudio from './static/visual_studio.png';
import windows from './static/windows.png';


const images =  {
    logo,
    bestSale,
    laptop,
    tablet1,
    tablet2,
    mobile,
    mouse,
    panorama,
    panoramaBadge,
    logoWhite,
    mobile3,
    shield,
    surfaceLaptop,
    surfaceLaptop2,
    windows,
    visualStudio
}

export default images;